const closedSalesApi = {
  closedSales: {
    submitRequest: '/api/closed_sale_request/submit',
    cancelRequest: '/api/closed_sale_request/cancel',
    cancelRequestV2: '/api/v2/closed_sale_request/cancel',
    checkRequest: '/api/closed_sale_request/status',
  },
};

export default closedSalesApi;

export const closedSalesApiConfig = closedSalesApi.closedSales;
